import { Characters, ItemName, Locale } from '@ps-smart-cp/ppfw-client';

interface Schema {
  password: string;
  verificationCode: string;
}

const attributes = {
  password: Characters.preset.freeFormat({ maxLen: 256, required: true }),
  verificationCode: Characters.preset.numerical({
    minLen: 6,
    maxLen: 6,
    required: true,
    pad: { position: 'start', with: '' },
  }),
};

const names = {
  password: ItemName.of([Locale.ja, 'パスワード'], [Locale.en, 'Password']),
  verificationCode: ItemName.of([Locale.ja, '認証コード'], [Locale.en, 'Verification Code']),
  enableMfa: ItemName.of([Locale.ja, 'MFAを有効化'], [Locale.en, 'Enable MFA']),
  disableMfa: ItemName.of([Locale.ja, 'MFAを無効化'], [Locale.en, 'Disable MFA']),
  post: ItemName.of([Locale.ja, '送信']),
  mfaSetting: ItemName.of([Locale.ja, 'MFA設定'], [Locale.en, 'MFA Setting']),
  mfaSetup: ItemName.of([Locale.ja, 'MFAセットアップ'], [Locale.en, 'MFA Setup']),
  mfaDisableDialog: ItemName.of([Locale.ja, 'MFAを無効化'], [Locale.en, 'Disable MFA']),
  installMfaApp: ItemName.of(
    [Locale.ja, '1. 認証アプリをインストールする'],
    [Locale.en, '1. Install authenticator app'],
  ),
  readQrCode: ItemName.of([Locale.ja, '2. QRコードを読み取る'], [Locale.en, '2. Scan the QR code']),
  enterVerificationCode: ItemName.of(
    [Locale.ja, '3. 認証コードの入力'],
    [Locale.en, '3. Enter the verification code'],
  ),
  mfaUnset: ItemName.of([Locale.ja, 'MFAは未設定です。'], [Locale.en, 'MFA is not configured.']),
  mfaEnable: ItemName.of([Locale.ja, 'MFAは有効です。'], [Locale.en, 'MFA is enabled.']),
  enterPassword: ItemName.of(
    [Locale.ja, 'MFA設定を変更する前にパスワードを入力してください。'],
    [Locale.en, 'Please enter your password before changing your MFA settings.'],
  ),
  confirmDisableMfa: ItemName.of(
    [Locale.ja, 'MFA設定を無効化します。よろしいですか？'],
    [Locale.en, 'Disable forced SSO. May I?'],
  ),
  mfaDeletionNote: ItemName.of(
    [Locale.ja, 'MFA設定が削除されます。次回有効にする際は、再設定が必要になります。'],
    [Locale.en, 'Your MFA settings will be removed. You will need to set it up again to re-enable it.'],
  ),
  installMfaAppDescription: ItemName.of(
    [
      Locale.ja,
      'スマートフォンに認証アプリ（推奨：Google Authenticator、Microsoft Authenticator）をインストールしてください。',
    ],
    [
      Locale.en,
      'Install an authenticator app (recommended: Google Authenticator, Microsoft Authenticator) on your smartphone.',
    ],
  ),
  readQrCodeDescription: ItemName.of(
    [Locale.ja, '認証アプリでQRコードを読み取ってください。'],
    [Locale.en, 'Scan the QR code with your authenticator app.'],
  ),
  enterKeyManuallyDescription: ItemName.of(
    [Locale.ja, 'QRコードを読み取れない場合は、以下のキーを手動で入力してください:'],
    [Locale.en, 'If you cannot scan the QR code, enter the following key manually:'],
  ),
  enterVerificationCodeDescription: ItemName.of(
    [Locale.ja, '認証アプリに表示された6桁の数字を入力し、「送信」ボタンを押してください。'],
    [Locale.en, 'Enter the 6-digit verification code generated by your app and click the "Post" button.'],
  ),
};

const mfaSetting = {
  attributes,
  names,
};

interface MfaSetting {
  schema: Schema;
}

export type { MfaSetting };
export { mfaSetting };
